import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from '../locales/en.json'
import it from '../locales/it.json'
import es from '../locales/es.json'
import fr from '../locales/fr.json'
import ar from '../locales/ar.json'
import de from '../locales/de.json'

i18next.use(initReactI18next).init({
  initImmediate: false,
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: { translation: en },
    it: { translation: it },
    es: { translation: es },
    fr: { translation: fr },
    ar: { translation: ar },
    de: { translation: de },
  },
  interpolation: {
    escapeValue: false,
  },
})

export function applyRTL(lang: string) {
  document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.lang = lang
}

export default i18next
